var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.source)?_c('LottieAnimation',{attrs:{"path":_vm.source,"loop":"","autoPlay":false,"speed":1,"width":512,"height":291},on:{"AnimControl":_vm.createListeners}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }